const DIACRITICAL_MARKS_REGEX = /[\u0300-\u036f]/g;
const NON_ALPHANUMERIC_REGEX = /[^a-z0-9]/g;
const CONSECUTIVE_DASHES_REGEX = /-+/g;
const LEADING_TRAILING_DASHES_REGEX = /^-|-$/g;

export const stringToClickNameAction = (input: string): string =>
  input
    .normalize('NFD') // Decompose accented characters
    .replace(DIACRITICAL_MARKS_REGEX, '') // Remove diacritical marks
    .toLowerCase()
    .replace(NON_ALPHANUMERIC_REGEX, '-') // Replace non-alphanumeric with dashes
    .replace(CONSECUTIVE_DASHES_REGEX, '-') // Replace multiple consecutive dashes with single dash
    .replace(LEADING_TRAILING_DASHES_REGEX, ''); // Remove leading/trailing dashes
